<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>Plantillas</h3>
      </div>
    </div>

    <!-- Crear -->
    <div class="row">
      <div class="col-xs-12 col-md-5">
        <div class="card">
          <div class="card__content">
            <div class="form-field">
              <input-field id="codigo" v-model="form.codigo" :readonly="modEditar">Código:</input-field>
            </div>
            <div class="form-field">
              <input-field id="descripcion" v-model="form.descripcion">Descripción:</input-field>
            </div>
            <div class="form-group">
              <div class="select2-field select2-field--stretch">
                <v-select
                  id="selectedMultipleUsuarios"
                  label="nombre"
                  v-model="form.usuarios"
                  :options="usuarios"
                  @input="inputSelectedMultiple"
                  multiple
                ></v-select>
                <label for="selectedMultipleUsuarios">Usuarios:</label>
              </div>
              <label for="todosUsuarios">
                <input
                  type="checkbox"
                  v-model="form.todosUsuarios"
                  @change="changeTodosSelectedMultiple"
                  id="todosUsuarios"
                  name="todosUsuarios"
                />
                <span>Todos</span>
              </label>
            </div>
            <div class="form-group mb-2">
              <div class="select2-field select2-field--stretch">
                <v-select
                  id="SelectedTipoReporte"
                  label="descripcion"
                  :options="tipos"
                  v-model="selectedTipoReporte"
                  @input="inputSelectedTipoReporte"
                ></v-select>
                <label for="SelectedTipoReporte">Tipo reporte:</label>
              </div>
              <label for="todosTipo">
                <input
                  type="checkbox"
                  v-model="form.todos_tipo_reporte"
                  @change="changeTodosTipo"
                  id="todosTipo"
                  name="todosTipo"
                />
                <span>Todos</span>
              </label>
            </div>
            <div class="form-group">
              <button
                v-show="puede_crear || puede_editar"
                type="submit"
                class="btn-success"
                @click="guardar"
              >
                <i class="fa fa-save"></i>
                <span>Guardar</span>
              </button>
              <button type="submit" class="btn-info ml-2" @click="nuevo">
                <i class="fa fa-plus"></i>
                <span>Nuevo</span>
              </button>
            </div>
          </div>
        </div>
        <details class="card card--collapsible">
          <summary class="card__title card__title--bg-primary">
            <div class="form-inline">
              <i class="fa fa-info-circle" aria-hidden="true"></i>
              <h5>Campos</h5>
            </div>
          </summary>
          <div class="card__content">
            <div class="row">
              <div class="col-xs-12" style="height: 350px; overflow-y: scroll">
                <checked-listbox
                  @input="inputColumna"
                  :items="campos"
                  :columns="2"
                  name="campos[]"
                  v-model="form.columnas"
                  field="nombre"
                ></checked-listbox>
              </div>
            </div>
          </div>
        </details>
      </div>
      <div class="col-xs-12 col-md-7">
        <div class="card">
          <div class="card__content">
            <div class="table-responsive mt-3">
              <k-table
                :buttons="[
                  {
                    class: 'btn-info',
                    icon: 'fa-edit',
                    event: 'editar'
                  },
                  {
                    class: 'btn-danger',
                    icon: 'fa-trash',
                    event: 'eliminar'
                  }
                ]"
                @eliminar="eliminar"
                @editar="editar"
                noForms
                :params="datos"
                :mostrarTodos="false"
                :columns="columns"
                :path="path"
                ref="consultarPlantillas"
                :deleteButton="false"
                :createButton="false"
                :editButton="false"
              ></k-table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import swal from "sweetalert2";

export default {
  props: {
    campos: {
      type: Array,
      required: false,
      default: () => []
    },
    usuarios: {
      type: Array,
      required: false,
      default: () => []
    },
    tipos: {
      type: Array,
      required: false,
      default: () => [
        {'value': 'G', 'descripcion': 'General'},
        {'value': 'U', 'descripcion': 'Updated'},
      ]
    },
    puede_crear: {
      type: Boolean,
      required: false,
      default: false
    },
    puede_editar: {
      type: Boolean,
      required: false,
      default: false
    },
    puede_eliminar: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function () {
    return {
      path: url + "/plantilla/cargar",
      selectedTipoReporte: null,
      form: {
        codigo: "",
        descripcion: "",
        columnas: [],
        usuarios: [],
        todosUsuarios: true,
        tipo_reporte: null,
        todos_tipo_reporte: true  
      },
      datos: {
        codigo: "",
        descripcion: ""
      },
      columns: [
        {
          display: "Código",
          value: "codigo"
        },
        {
          display: "Descripción",
          value: "descripcion"
        },
        {
          display: "Tipo",
          value: "tipo_parseado"
        }
      ],
      modEditar: false,
    }
  },
  methods: {
    inputColumna: function (value) {
      this.form.columnas = value;
    },
    nuevo: function () {
      const that = this;
      swal({
        title: `¿Deseas limpiar el formulario?`,
        text: `El formulario será limpiado.`,
        type: "question",
        showCancelButton: true,
        confirmButtonText: `Limpiar`,
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.value) {
          that.limpiar();
        }
      });
    },
    editar: function (row) {
      const that = this;
      if (!that.puede_editar) {
        swal(
          "No tiene permiso para editar",
          "Error",
          "error"
        );
        return;
      }
      that.limpiar();
      that.modEditar = true
      axios
        .get(url + "/plantilla/" + row.codigo)
        .then(({ data }) => {
          that.form.columnas = data.campos;
          that.form.codigo = data.plantilla.codigo;
          that.form.descripcion = data.plantilla.descripcion;
          if (data.plantilla.tipo_reporte === 'T') {
            that.form.todos_tipo_reporte = true;
          } else {
            that.form.todos_tipo_reporte = false;
            that.form.tipo_reporte = data.plantilla.tipo_reporte;
            that.selectedTipoReporte = that.tipos.find( tipo => tipo.value === data.plantilla.tipo_reporte);
          }
          if (data.usuarios == null) {
            that.form.todosUsuarios = true;
            that.form.usuarios.splice(0, that.form.usuarios.length);
          } else {
            that.form.todosUsuarios = false;
            that.form.usuarios = data.usuarios;
          }
        })
        .catch(error => {
          swal(
            "Hubo un error al cargar. " + error,
            "Error",
            "error"
          );
        });
    },
    eliminar: function (row) {
      const that = this;
      if (!that.puede_eliminar) {
        swal(
          "No tiene permiso para eliminar",
          "Error",
          "error"
        );
        return;
      }
      swal({
        title: `¿Deseas eliminar esta plantilla ? `,
        text: `La plantilla será eliminada.`,
        type: "question",
        showCancelButton: true,
        confirmButtonText: `Eliminar`,
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.value) {
          axios
            .delete(url + "/plantilla/" + row.codigo)
            .then(() => {
              swal(
                "Plantilla eliminada correctamente",
                "Aviso",
                "success"
              );
              that.buscar();
            })
            .catch(error => {
              swal(
                "Hubo un error al actualizar. " + error,
                "Error",
                "error"
              );
            });
        }
      });
    },
    buscar: function () {
      this.$refs.consultarPlantillas.loadRows();
    },
    guardar: function () {
      const that = this;
      if (that.form.codigo != "" && that.form.descripcion != "" && that.form.columnas.length > 0) {
        const modo = that.modEditar ? ["actualizar", "actualizada"] : ["almacenar", "almacenada"];
        swal({
          title: `¿Deseas ${modo[0]} la plantilla ? `,
          text: `La plantilla será ${modo[1]}.`,
          type: "question",
          showCancelButton: true,
          confirmButtonText: `${that.modEditar ? "Actualizar" : "Almacenar"} plantilla`,
          cancelButtonText: "Cancelar",
        }).then((result) => {
          if (result.value) {
            if (that.modEditar) {
              axios
                .put(url + '/plantilla', that.form)
                .then(() => {
                  swal(
                    "Plantilla actualizada",
                    "Aviso",
                    "success"
                  );
                  that.limpiar();
                })
                .catch(error => {
                  swal(
                    "Hubo un error al cargar. " + error,
                    "Error",
                    "error"
                  );
                });
            } else {
              axios
                .post(url + '/plantilla', that.form)
                .then(() => {
                  swal(
                    "Plantilla almacenada",
                    "Aviso",
                    "success"
                  );
                  that.limpiar();
                })
                .catch(error => {
                  swal(
                    "Hubo un error al cargar. " + error,
                    "Error",
                    "error"
                  );
                });
            }
            that.buscar();
          }
        });
      } else {
        swal(
          "Debe completar todos los campos.",
          "Aviso",
          "warning"
        );
      }
    },
    limpiar: function () {
      this.modEditar = false;
      this.form.codigo = "";
      this.form.descripcion = "";
      this.form.todosUsuarios = true;
      this.selectedTipoReporte = null;
      this.form.tipo_reporte = null;
      this.form.todos_tipo_reporte = true;
      this.form.usuarios.splice(0, this.form.usuarios.length);
      this.form.columnas.splice(0, this.form.columnas.length);
    },
    inputSelectedMultiple: function () {
      this.form.todosUsuarios = false;
    },
    changeTodosSelectedMultiple: function () {
      if (this.form.todosUsuarios) {
        this.form.usuarios = [];
      }
    },
    inputSelectedTipoReporte: function () {
      if (this.selectedTipoReporte !== null) {
        this.form.todos_tipo_reporte = false;
        this.form.tipo_reporte = this.selectedTipoReporte.value;
      } else {
        this.form.tipo_reporte = null;
      }
    },
    changeTodosTipo: function () {
      if(this.form.todos_tipo_reporte) {
        this.selectedTipoReporte = null;
        this.form.tipo_reporte = null;
      }
    }
  },
  computed: {

  },
  mounted: function () {

  },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/forms/plantillas/Plantilla.vue